import React from "react";
import { motion } from "framer-motion";
import { SERVICES } from "../data";

const ServiceRow = ({ s, index }) => {
  const flip = index % 2 === 1;
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      className={`grid grid-cols-1 md:grid-cols-12 gap-8 items-center ${flip ? "md:[direction:rtl]" : ""}`}
      data-testid={`service-${s.num}`}
    >
      <div className="md:col-span-7 [direction:ltr]">
        <div className="relative overflow-hidden group h-[340px] md:h-[520px] border border-white/10">
          <img
            src={s.image}
            alt={s.title}
            className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/30" />
        </div>
      </div>
      <div className="md:col-span-5 [direction:ltr]">
        <span className="font-serif text-5xl md:text-7xl text-gold/25 block mb-4">{s.num}</span>
        <h3 className="font-serif font-light text-4xl md:text-6xl tracking-tight mb-6">{s.title}</h3>
        <p className="text-white/50 text-lg font-body font-light leading-relaxed">{s.desc}</p>
      </div>
    </motion.div>
  );
};

export const Services = () => {
  return (
    <section id="services" className="py-32 md:py-40 bg-[var(--nl-bg-2)] border-y border-white/10" data-testid="services">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="mb-20 md:mb-28 max-w-3xl">
          <p className="label text-gold mb-6">What We Do</p>
          <h2 className="font-serif font-light text-5xl md:text-7xl tracking-tighter leading-[0.95]">
            Occasions worthy of a <span className="italic text-gold">chauffeur.</span>
          </h2>
        </div>

        <div className="space-y-24 md:space-y-36">
          {SERVICES.map((s, i) => (
            <ServiceRow key={s.num} s={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
